module.exports = __webpack_public_path__ + "static/media/sort-down.784a6bf4.svg";